var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{class:_vm.$style.name},[_vm._v(_vm._s(_vm.message.payload.name))]),_c('a',{attrs:{"href":`tel:${_vm.message.payload.phone}`}},[_vm._v(" "+_vm._s(_vm.message.payload.phone)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }